

import initialState from '../initialState';
import * as types from './actionTypes.config';

const initialStateObj = {
    ...initialState.config
};

export default function ConfigReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.GET_FEATURES_CONFIG_OK:
            return {
                ...state,
                ...{
                    features: action.features
                }
            };

        case types.GET_VOICES_CONFIG_OK:
            return {
                ...state,
                ...{
                    voices: action.voices
                }
            };

        case types.GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_OK:
            return {
                ...state,
                ...{
                    acousticModels: action.acousticModels
                }
            };

        case types.GET_SLU_VERSION_CONFIG_OK:
            return {
                ...state,
                ...{
                    sluVersions: action.sluVersions
                }
            };

        default:
            return state;
    }
}